import { render, staticRenderFns } from "./Certified.vue?vue&type=template&id=7f53bfae&scoped=true&"
import script from "./Certified.vue?vue&type=script&lang=js&"
export * from "./Certified.vue?vue&type=script&lang=js&"
import style0 from "./Certified.vue?vue&type=style&index=0&id=7f53bfae&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f53bfae",
  null
  
)

export default component.exports